<template>
  <div class="project-scroll-page">
    <div class="header">
      <img src="@/assets/images/project-scroll/logo.png" alt="">
      <div class="title">项目信息公告</div>
    </div>
    <div class="main">
      <asset-transaction
        title="国有资产交易"
        type="1"
        subtitle="/ 公开  公平  公正  规范"
      />
      <purchase-block
        title="阳光招标采购"
        subtitle="/ 高效便捷  要素集中  创新业态  阳光公开"
        icon="purchase"
      />
      <asset-transaction
        title="自然资源交易"
        type="2"
        subtitle="/ 创新  协调  绿色  开放  共享"
      />
    </div>
  </div>
</template>

<script>
import AssetTransaction from "@/views/projectScroll/components/AssetTransaction.vue";
import PurchaseBlock from "@/views/projectScroll/components/PurchaseBlock.vue";
export default {
  name: "ProjectScroll",
  components: { AssetTransaction, PurchaseBlock },
  data() {
    return {};
  },
  mounted() {
    console.log("ProjectScroll mounted");
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.project-scroll-page {
  .header {
    width: 100%;
    padding: 0 5%;
    height: 120px;
    background-color: #fff;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #e15717;
    .title {
      font-size: 30px;
      font-weight: bold;
      color: #333;
      width: calc(100% - 408px);
      text-align: center;
      margin-left: -204px;
    }
  }
  .main {
    padding-bottom: 20px;
    width: 100%;
    padding: 0 5%;
  }
}
</style>
